import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: '20px 10px',
    '& *': {
      textAlign: 'center',
      fontFamily: 'Mulish',
    },
  },
  title: {
    color: '#000000',
    fontFamily: 'Mulish',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '33px',
  },
  arrowedTitle: (props: { baseColors: BaseColors }) => {
    return {
      width: '100%',
      padding: '10px 0 5px 0',
      fontSize: '23px',
      // color: '#6eddf5',
      color: props.baseColors.secondary,
    }
  },
  bluebar: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      width: '100%',
      minWidth: '40px',
      maxWidth: props.isMobile ? '40px' : '100px',
      height: '4px',
      background: `linear-gradient(270deg, ${props.baseColors.secondary} 0%, rgba(110, 221, 245, 0) 100%)`,
    }
  },
  orgName: {
    color: '#878787',
    padding: '20px 0 5px 0',
    fontSize: '28px',
  },
  altText: {
    color: 'black',
    textAlign: 'center',
    padding: '20px 0 5px 0',
    fontSize: '38px',
  },
}))

export default buildStyles
